<script>
    import countTo from "vue-count-to";
    import Statistics from '@/services/Statistics';
    import General from '@/services/General';

    export default {
        components: {
            countTo
        },
        data() {
            return {
                showRegisteredUsers: false,
                user_count: 0,
                user_count_weekly: 0,
                orders_total: 0.00,
                orders_count: 0,
                change_percent: 0,
                days: 30,
                graph_days: 30,
                graph_months: 12,
                graph_type: 'daily',
                graph_data_type: 'orders',
                showLoader: false,
                series: [{ data: [0] }],
                orders_merchandising: [],
                showOrdersStatistics: false,
                options: {
                    chart: {
                        id: 'vuechart-example'
                    },
                    xaxis: {
                        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
                    }
                },
                salesSeries: [
                    { name: 'Merchandising count', type: 'line', data: [] },
                    { name: 'Merchandising sum', type: 'column', data: [] },
                    { name: 'New Registered Users', type: 'column', data: [] }
                ],
                salesChartOptions: {
                    chart: {
                        type: 'line',
                        height: 390,
                        stacked: false,
                        toolbar: { show: false }
                    },
                    stroke: { width: [2, 0] },
                    plotOptions: { bar: { columnWidth: '50%' } },
                    dataLabels: { enabled: false },
                    fill: { opacity: [0.85, 0.25, 1] },
                    colors: ['#5b73e8', '#e8e9eb', '#f1b54d'],
                    labels: [],
                    xaxis: { type: 'category' },
                    yaxis: [
                        { title: { text: '' } },
                        { opposite: true, title: { text: '' } }
                    ],
                    tooltip: { shared: true, intersect: false },
                    animations: {
                        enabled: true,
                        easing: 'linear',
                        speed: 1500,
                        animateGradually: { enabled: true, delay: 1500 },
                        dynamicAnimation: { enabled: true, speed: 1500 }
                    }
                },
                growthChartOptions: {
                    fill: { colors: ["#f1b44c"] },
                    chart: { type: "bar", sparkline: { enabled: true } },
                    plotOptions: { bar: { columnWidth: "50%" } },
                    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
                    xaxis: { crosshairs: { width: 1 } },
                    tooltip: {
                        fixed: { enabled: false },
                        x: { show: false },
                        y: { title: { formatter: () => "" } },
                        marker: { show: false }
                    }
                },
                orderseries: [70],
                orderRadial: {
                    fill: { colors: ["#34c38f"] },
                    chart: { sparkline: { enabled: true } },
                    dataLabels: { enabled: false },
                    plotOptions: {
                        radialBar: {
                            hollow: { margin: 0, size: "60%" },
                            track: { margin: 0 },
                            dataLabels: { show: false }
                        }
                    }
                },
                customerseries: [55],
                customerRadial: {
                    fill: { colors: ["#5b73e8"] },
                    chart: { sparkline: { enabled: true } },
                    dataLabels: { enabled: false },
                    plotOptions: {
                        radialBar: {
                            hollow: { margin: 0, size: "60%" },
                            track: { margin: 0 },
                            dataLabels: { show: false }
                        }
                    }
                }
            };
        },
        async created() {
            this.showRegisteredUsers = await this.checkObjectAccessCall('kpi.dashboard.registered_users');
        },
        async mounted() {
            this.getOrdersTotalsStatistics();
            this.getOrdersStatisticsByType();
            this.getCustomerStatistics();
        },
        methods: {
            async getCustomerStatistics() {
                try {
                    await Statistics.getCustomerStatistics(this.days, {})
                        .then((response) => {
                            this.user_count = response.data.data.user_count;
                            this.user_count_weekly = response.data.data.user_count_weekly;
                        })
                        .catch((error) => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error);
                        });
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg(this.error);
                }
            },

            async getOrdersStatisticsByTypeTotalCount() {
                try {
                    const response = await Statistics.getOrdersStatisticsByType(this.graph_days, this.graph_type, {});
                    this.showOrdersStatistics = response.data.data.data.length > 0;
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg(this.error);
                    this.showOrdersStatistics = false;
                }
            },

            async getOrdersTotalsStatistics() {
                try {
                    await Statistics.getOrdersTotalStatistics(this.days, {})
                        .then((response) => {
                            this.orders_total = parseFloat(response.data.data.orders_total);
                            this.orders_count = response.data.data.orders_count;
                            this.change_percent = response.data.data.change_percent;
                            this.series[0].data = response.data.data.orders_per_day.map(order => parseFloat(order.orders_total));
                        })
                        .catch((error) => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error);
                        })
                        .finally(() => {
                            this.updateSeriesLine();
                        });
                } catch (error) {
                    console.error("Error fetching orders totals:", error);
                }
            },

            async getOrdersStatisticsByType() {
                this.showLoader = true;
                try {
                    await Statistics.getOrdersStatisticsByType(this.graph_days, this.graph_type, {})
                        .then((response) => {
                            this.updateSalesChart(response.data.data);
                        })
                        .catch((error) => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error);
                        })
                        .finally(() => {
                            this.showLoader = false;
                        });
                } catch (error) {
                    console.error("Error fetching orders statistics:", error);
                }
            },

            updateSeriesLine() {
                if (this.$refs.realtimeChart && this.series && this.series[0] && Array.isArray(this.series[0].data)) {
                    this.$refs.realtimeChart.updateSeries([{ data: this.series[0].data }], false, true);
                }
            },

            goToURL(url) {
                window.location.href = `/${url}`;
            },

            updateSalesChart(data) {
                if (!data || !data.data || !Array.isArray(data.data) || data.data.length === 0) {
                    console.error("❌ Data is invalid or empty.");
                    this.salesSeries = [];
                    return;
                }

                if (this.graph_data_type === "newRegisteredUser") {
                    if (!data.data[0] || !data.data[0].data) {
                        console.error("❌ Data structure is invalid: data.data[0].data is missing.");
                        this.salesSeries = [];
                        return;
                    }

                    const userData = data.data[0].data;
                    this.salesSeries = [{ name: 'New Registered Users', type: 'column', data: userData }];
                    this.salesChartOptions = {
                        labels: data.labels || [],
                        colors: ['#5b73e8', '#4a5cb6', '#f1b54d'],
                        stroke: { width: [2, 0] },
                        fill: { opacity: [0.85, 0.25] },
                        yaxis: [{ title: { text: 'Users' } }]
                    };
                } else if (this.graph_data_type === "orders") {
                    if (!Array.isArray(data.data) || data.data.length < 2 || !data.data[0]?.data || !data.data[1]?.data) {
                        this.salesSeries = [];
                        return;
                    }

                    const countData = data.data[0].data;
                    const sumData = data.data[1].data;

                    this.salesSeries = [
                        { name: 'Merchandising count', type: 'line', data: countData },
                        { name: 'Merchandising sum', type: 'column', data: sumData }
                    ];
                    this.salesChartOptions = {
                        labels: data.labels || [],
                        colors: ['#5b73e8', '#4a5cb6', '#f1b54d'],
                        stroke: { width: [2, 0] },
                        fill: { opacity: [0.85, 0.25] },
                        yaxis: [
                            { title: { text: 'Count' } },
                            { opposite: true, title: { text: 'Sum' } }
                        ]
                    };
                }
            },

            async getNewRegisteredUsersStatistics() {
                this.showLoader = true;
                try {
                    await Statistics.getNewRegisteredUsersStatistics(this.graph_days, this.graph_type, {})
                        .then((response) => {
                            this.updateSalesChart(response.data.data);
                        })
                        .catch((error) => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error);
                        })
                        .finally(() => {
                            this.showLoader = false;
                        });
                } catch (error) {
                    console.error("Error fetching new registered users:", error);
                }
            },

            getGraphStatistics() {
                if (this.graph_data_type === "orders") {
                    this.getOrdersStatisticsByType(this.graph_days, this.graph_type, {});
                } else if (this.graph_data_type === "newRegisteredUser") {
                    this.getNewRegisteredUsersStatistics(this.graph_days, this.graph_type, {});
                }
            },

            getOrdersStatistics() {
                if (this.graph_data_type === "orders") {
                    if (this.graph_type === "daily") {
                        this.getOrdersStatisticsByType(this.graph_days, 'daily', {});
                    } else if (this.graph_type === "monthly") {
                        this.getOrdersStatisticsByType(this.graph_months, 'monthly', {});
                    }
                }else if (this.graph_data_type === "newRegisteredUser") {
                    if (this.graph_type === "daily") {
                        this.getNewRegisteredUsersStatistics(this.graph_days, 'daily', {});
                    } else if (this.graph_type === "monthly") {
                        this.getNewRegisteredUsersStatistics(this.graph_months, 'monthly', {});
                    }
                }
            }
        }
    };
</script>

<template>
<div class="row">

    <div class="col-md-6 col-xl-3">
        <div class="card">
            <div class="card-body elementPointed" @click="goToURL('orders')">
                <div class="float-end mt-2">
                    <i class="fas fa-credit-card fa-3x"></i>
                   <!--  <apexchart v-if="orders_total > 0" ref="realtimeChart" class="apex-charts" dir="ltr" width="70" height="40" :options="growthChartOptions" :series="series"></apexchart>
                    <i v-else class="fas fa-credit-card fa-3x"></i> -->
                </div>
                <div>
                    <h4 class="mb-1 mt-1">
                        <span data-plugin="counterup">
                            MKD<countTo :startVal="0.00" :endVal="orders_total" :decimals="2" decimal="." :duration="2000"></countTo>
                        </span>
                    </h4>
                    <h5 class="text-muted mb-0">Orders ({{days}} days)</h5>
                </div>
                <p class="text-muted mt-3 mb-0">
                      <!-- <span class="me-1 text-primary font-size-16">{{orders_count > 0 ? orders_count : 0 }}</span> total orders -->

                     <span v-if="change_percent === null" class="me-1">
                         <i class="fas fa-info-circle me-1 font-size-16"></i>No data to compare with
                     </span>
                     <span v-else-if="change_percent >= 0" class="text-success me-1">
                        <i class="mdi mdi-arrow-up-bold me-1 font-size-16"></i>{{change_percent}}% vs. previous {{days}} days
                     </span>
                     <span v-else class="text-danger me-1 font-size-16">
                        <i class="mdi mdi-arrow-down-bold me-1 font-size-16"></i>{{change_percent}}% vs. previous {{days}} days</span>

                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body elementPointed" @click="goToURL('customers')">
                <div class="float-end mt-2">
                    <i class="fas fa-users fa-3x"></i>
                </div>
                <div>
                    <h4 class="mb-1 mt-1">
              <span data-plugin="counterup">
                <countTo
                        :startVal="0"
                        :endVal="user_count"
                        :duration="2000"
                ></countTo>
              </span>
                    </h4>
                    <h5 class="text-muted mb-0">Registered Users</h5>
                </div>
                <p class="text-muted mt-3 mb-0">
            <span v-if="user_count_weekly > 0" class="text-success me-1">
              <i class="mdi mdi-arrow-up-bold me-1 font-size-16"></i
              >{{ user_count_weekly }}
            </span>
                    <span v-else class="text-danger me-1 font-size-16">
              <i class="mdi mdi-arrow-down-bold me-1 font-size-16"></i
              >{{ user_count_weekly }}</span
                    >
                    last {{ days }} days
                </p>
            </div>
        </div>
    </div>
    <!-- end col-->




<!--!!!sales chart is used to plot customers and devices data also-->
    <!--  <div class="row"> -->
          <div class="col-xl-8" :style="{'width': '100%;'}">
              <div class="card">
                  <div class="card-body">
                      <div class="col-sm-4 float-start">
                          <template>
                              <select v-model="graph_data_type" class="form-select"  @change="getGraphStatistics()">
                                  <option value="orders" selected>Orders</option>
                                  <option value="newRegisteredUser" selected
                                  >New Registered Users</option>
                              </select>
                          </template>
<!--                          <template v-if="showOrdersStatistics == true">-->
<!--                              <select-->
<!--                                      v-model="graph_data_type"-->
<!--                                      class="form-select"-->
<!--                                      @change="getGraphStatistics()"-->
<!--                              >-->
<!--                                  <option value="customerDevices" selected-->
<!--                                  >New Registered Users</option-->
<!--                                  >-->
<!--                                  <option value="orders">Orders</option>-->
<!--                              </select>-->
<!--                          </template>-->
<!--                          <template v-else>-->
<!--                              <select-->
<!--                                      v-model="graph_data_type"-->
<!--                                      class="form-select"-->
<!--                                      @change="getGraphStatistics()"-->
<!--                              >-->
<!--                                  <option value="customerDevices" selected-->
<!--                                  >New Registered Users</option-->
<!--                                  >-->
<!--                              </select>-->
<!--                          </template>-->

                      </div>
                      <div class="col-sm-2 float-end">
                          <select v-model="graph_type" class="form-select"  @change="getOrdersStatistics()">
                              <option value="daily" selected>Daily</option>
                              <option value="monthly">Monthly</option>
                          </select>
                      </div><br>

                      <div class="mt-3 p-2" >
                          <div class="card-body d-flex align-items-center justify-content-center" v-if="showLoader">
                              <!--  <b-spinner large></b-spinner> -->
                          </div>
                          <apexchart id="salesChart" data-colors='["--bs-primary", "#dfe2e6", "--bs-warning"]' class="apex-charts" ref="salesChart"
                                :options="salesChartOptions" :series="salesSeries" >
                          </apexchart>
                      </div>

                  </div> <!-- end card-body-->
              </div> <!-- end card-->
          </div> <!-- end col-->




</div> <!-- end row-->
</template>
